import {ThreeWayToggle} from '@modules/three-way-toggle';

export default (ctx, html) => html`
  ${ctx.state === ThreeWayToggle.VALUES.ALL? html`
    <span class="ai ai-checkmark text-primary"></span>
  `: ''}

  ${ctx.state === ThreeWayToggle.VALUES.SOME? html`
    <span class="ai ai-checkmark text-warning"></span>
  `: ''}

  ${ctx.state === ThreeWayToggle.VALUES.NONE? html`
    <span class="ai ai-close-icon text-danger"></span>
  `: ''}

  ${typeof ctx.state === 'undefined'? html`
    <span class="ai ai-close-icon text-danger"></span>
  `: ''}
`;
